import { render, staticRenderFns } from "./ProductListPlaceholder.vue?vue&type=template&id=8955de64"
import script from "./ProductListPlaceholder.vue?vue&type=script&lang=js"
export * from "./ProductListPlaceholder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports